import {createContext} from "react";
import {GlobalContextHooks} from "../hooks/GlobalContextHooks";

export const GlobalMessageContext = createContext()

export const GlobalMessageProvider = ({ children }) => {
    return (
        <GlobalMessageContext.Provider value={GlobalContextHooks()}>
            {children}
        </GlobalMessageContext.Provider>
    )
}